import React from "react";
import _ from "lodash";
import Underline from "assets/images/CT/underline.png";
import activeTab from "assets/images/CT/activeTab.svg";

const KeyInformation = (props) => {
  const [tabSelected, setTabSelected] = React.useState("GameKey");
  const { room_obj } = props;
  const join_code = _.get(room_obj, "join_code");
  return (
    <>
      <div className="conspiracy-information-wrapper">
        <div className="conspiracy-information">
          <ul className="tab-list">
            <li
              img
              src={activeTab}
              onClick={() => setTabSelected("GameKey")}
              className={tabSelected === "GameKey" ? "active" : "inactive"}
            >
              GAME KEY
            </li>
            <li
              onClick={() => setTabSelected("Doubles")}
              className={tabSelected === "Doubles" ? "active" : "inactive"}
            >
              Doubles
            </li>
            <li
              onClick={() => setTabSelected("Discover")}
              className={tabSelected === "Discover" ? "active" : "inactive"}
            >
              Discover
            </li>
          </ul>
          <div
            className={
              tabSelected === "Discover"
                ? "discover-bg"
                : tabSelected === "Doubles"
                ? "double-bg"
                : "game-key-bg"
            }
          ></div>
        </div>
        <div
          onClick={() => {
            props.joinRoom();
          }}
          className="ct-join-code"
        >
          <label>Join Code:</label>
          <div className="join-code-btn">
            <button> {join_code}</button>
            <img src={Underline} alt="underline" />
          </div>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
              className="copy-icon"
              fill="black"
              d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"
            />
          </svg>
        </div>
      </div>
    </>
  );
};

export default KeyInformation;
